
/* eslint-disable */
import axios from 'axios';

export default {
    state : {
        bill : null,
        nal : [],
        besnal : [],
    },

    methods : {

    },

    getters : {
        getBillData(state){
            return state.bill;
        },

        getNal(state) {
            return state.nal;
        },

        getBeznal(state) {
            return state.besnal;
        }

    },

    mutations: {
        
        clearBillData(state) {
            state.nal = [];
            state.besnal = [];
            state.bill = null;
        },

        updateNal(state, nal) {
            let index = state.nal.findIndex(item => item.id === nal.id);
            state.nal.splice(index, 1, nal);
        },

        setBill(state, bill){
            if (bill != undefined) {
                state.bill = bill;
            }
        },

        setNal(state, nal) {
            state.nal = nal;// заменяем данные по наличке
        },

        setBeznal(state, data) {
            state.besnal = data;
        },

        addNal(state, nal) {
             state.nal.push(nal);
        }

    },

    actions : {

        combineBills({rootGetters, rootState}) { // объединяем счета
            return new Promise((resolve, reject) => {

                axios.post('/combineBills', rootGetters.getSelectedOrders)
                .then(response => {
                    // context.commit('updateNal', response.data);
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'updateOrders', 'content' : response.data});
                    resolve(response.data);

                })
                .catch(error=> {
                    reject(error);
                    console.log(error)
                });
            });

        },

        checkBillNumber({rootState, rootGetters}, data) {
            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;  
                data['selectedOrders'] =  rootGetters.getSelectedOrders;
                axios.post('/checkBillNumber', data)
                .then(response => {
                    // context.commit('updateNal', response.data);
                    resolve(response.data);
                })
                .catch(error=> {
                    reject(error);
                    console.log(error)
                });
            });

        },

        deleteMarkNal(context, nalId) {
            return new Promise((resolve, reject) => {
                axios.post('/delNal/'+nalId)
                .then(response => {
                    context.commit('updateNal', response.data);
                    resolve(response.data);
                })
                .catch(error=> {
                    reject(error);
                    console.log(error)
                });
            });


        },
        getBill(context, billId) {
            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;  
                axios.post('/getBill', {billId : billId})
                .then(response => {
                    context.commit('setBill', response.data);
                    resolve(response.data);
                })
                .catch(error=> {
                    reject(error);
                    console.log(error);
                });
            });
        },

        saveBill({commit, state, rootState, rootGetters}, param) {
            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;  
                axios.post('/addBill', param)
                .then(response => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'updateOrders', 'content' : response.data});
                    resolve(response.data);

                })
                .catch(error=> {
                    reject(error)
                    console.log(error)
                });

            });
        },

        getNal({commit, state, rootState}) {

            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;  
                axios.get('/getNal/'+state.bill.id)
                .then(response => {
                    commit('setNal', response.data);
                    resolve(response.data);

                })
                .catch(error=> {
                    reject(error)
                    console.log(error)
                });

            });

        },

        getCommings({commit, state, rootState}) {
            
            return new Promise((resolve, reject) => {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;  
                axios.get('/getComming/'+state.bill.id)
                .then(response => {
                    commit('setNal', response.data['nal']);
                    commit('setBeznal', response.data['beznal']);
                    resolve(response.data);

                })
                .catch(error=> {

                    reject(error)
                });

            });
        },


        deleteFromBill({commit, state, rootState, rootGetters}, orderId) { // удаляет заказ из счета
            return new Promise((resolve, reject)=> {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token; 
                axios.delete('/deleteFromBill/' + orderId)
                .then(response=>{
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'updateOrder', 'content' : response.data});  // обновляем ордер
                    commit('deleteFromBill', response.data.id);
                    commit('selectOrder', response.data); // убираем выделение с заказа
                })
                .catch(error => {
                    reject(error);
                });
            });
        },

        saveNal({rootState, dispatch,  commit, rootGetters}, data) {

            return new Promise((resolve, reject) => {
                let _data = data;
                // _data.selected = rootGetters.getSelectedOrders;// получаем список отмеченных файлов - чтобы если счета нет - создать новый и привязать к нему заказы
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;  
                console.log(data);
                if (data.billId == null) { // значит еще нет счета - надо его создать
                    dispatch('saveBill', {billParam : {org:0, number : null, bill_at : new Date(), notUnlock : 1, selectedOrders:rootGetters.getSelectedOrders}, selectedOrders:rootGetters.getSelectedOrders})
                    .then(response=>{
                        // нужно выцепить номер счета
                        console.log(response);
                        response.forEach(element => {
                            _data.billId = element.bill_out;  
                            console.log('--->'+_data.billId);
                        });

                        axios.post('/saveNal', _data)
                        .then(response => {
                            commit('addNal', response.data);
                            resolve(response.data);
    
                        })
                        .catch(error=> {
                            reject(error)
                            console.log(error)
                        });
                    })
                    .catch(error => {
                        reject(error)
                        console.log(error);
                    })
                } else {
                    axios.post('/saveNal', _data)
                    .then(response => {
                        commit('addNal', response.data);
                        resolve(response.data);

                    })
                    .catch(error=> {
                        reject(error)
                        console.log(error)
                    });
                }

            });

        }

    }

}